import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  P,
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
const DIv = styled.div`
  text-align: left;
`;
const Headings = styled.div`
  padding: 30px 0;
  background-color: #004f64;
  font-size: 25px;
  font-family: "Poppins-Medium";
  text-align: center;
  color: #fff;
`;
const Content = styled.div`
  min-height: 200px;
  background-color: #100f0f;
  padding: 20px 30px;
  text-align: center;
  color: #000;
`;

const ReadMore = styled.a`
  text-decoration: none;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "#fff")};
  color: ${(props) => (props.color ? props.color : "#000")};
  border: ${(props) => (props.border ? props.border : "1px solid #fff")};
  opacity: ${(props) => (props.opacity ? props.opacity : "1")};
  border-radius: 10px;
  padding: 8px 40px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "5px 27px")};
  }
  &:hover {
    opacity: ${(props) => (props.hoveropacity ? props.hoveropacity : "0.9")};
  }
`;
const index = () => {
  return (
    <div id="ecosystem">
      <SectionWrapper p="100px 0">
        <Container maxWidth="xl">
          <SectionHeading p="50px 0" align="left">
            Ecosystem
          </SectionHeading>
          <P p="20px 0">
            {/* Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt
            ut labore et dolore magna
            <br /> aliquyam erat, sed diam voluptua. At vero eos et accusam et */}
          </P>
          <Grid container spacing={6} sx={{justifyContent:"center"}}>
            <Grid item xs={12} sm={6} md={4}>
              <Headings>
                Blockchain
                <br /> Explorer
              </Headings>
              <Content>
                <P>
                  Blockchain Explorer will allow you to track all transactions
                  that take place within the POA network
                </P>
                <br />
                <ReadMore
                  border="1px solid #fff"
                  color="#fff"
                  bgcolor="TRANSPARENT"
                  href="/"
                  target="_blank"
                >
                  View
                </ReadMore>
                <br />
                <br />
              </Content>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Headings>
                Degenape <br />
                Swap
              </Headings>
              <Content>
                <P>
                  The swap will allow users to deploy, buy and sell tokens on
                  our chain
                </P>
                <br />
                <br />
                <ReadMore
                  border="1px solid #fff"
                  color="#fff"
                  bgcolor="TRANSPARENT"
                  href="/"
                  target="_blank"
                >
                  View
                </ReadMore>
                <br />
                <br />
              </Content>
            </Grid>{" "}
            <Grid item xs={12} sm={6} md={4}>
              <Headings>
                Decentralized
                <br /> Launchpad
              </Headings>
              <Content>
                <P>
                  Users can create and/or participate in upcoming presales on
                  our launchpad
                </P>
                <br />
                <br />
                <ReadMore
                  hoveropacity="0.5"
                  opacity="0.5"
                  border="1px solid #fff"
                  color="#fff"
                  bgcolor="TRANSPARENT"
                  // href="/"
                  target="_blank"
                >
                  Coming Soon
                </ReadMore>
                <br />
                <br />
              </Content>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Headings>
                Liquidity
                <br /> Locker
              </Headings>
              <Content>
                {/* <P>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum.
                </P> */}
                <br />
                <ReadMore
                  hoveropacity="0.5"
                  opacity="0.5"
                  border="1px solid #fff"
                  color="#fff"
                  bgcolor="TRANSPARENT"
                  // href="/"
                  target="_blank"
                >
                  Coming Soon
                </ReadMore>
                <br />
                <br />
              </Content>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Headings>
                Apemask
                <br /> Wallet
              </Headings>
              <Content>
                {/* <P>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum.
                </P> */}
                <br />
                <ReadMore
                  hoveropacity="0.5"
                  opacity="0.5"
                  border="1px solid #fff"
                  color="#fff"
                  bgcolor="TRANSPARENT"
                  // href="/"
                  target="_blank"
                >
                  Coming Soon
                </ReadMore>
                <br />
                <br />
              </Content>
            </Grid>{" "}
          </Grid>{" "}
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
